import { Navigate } from "react-router-dom";
import { Layout } from "../components";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";

interface Props {
  children: JSX.Element | JSX.Element[];
}
export const PublicRoute = ({ children }: Props) => {
  const { validateToken, idRole } = useContext(AuthContext);
  if (validateToken()) {
    return idRole === 3 ? (
      <Navigate to="/proposal" replace />
    ) : (
      <Navigate to="/home" replace />
    );
  } else {
    return <Layout>{children}</Layout>;
  }
};
